import { fetchWithFallback, dateRangeParams } from "../OrgUsageAnalytics/api";

/**
 * Client Tracking talks to the same admin analytics function as the User Usage
 * pages, so it reuses their transport (env fallback chain, admin token, the
 * double `/admin` prefix) rather than re-deriving it here.
 */
export { dateRangeParams };

/**
 * One row per active organization for the window, plus the global day/week
 * series, cross-client totals, and each client's deterministic health signals.
 *
 * @param {{ startDate: string, endDate: string, search?: string,
 *   sort?: string, activeOnly?: string, includeInternal?: string,
 *   limit?: string }} params
 * @param {"prod"|"dev"|"local"} env
 */
export const fetchClientTracking = (params, env) =>
  fetchWithFallback("/usage-analytics/client-tracking", params, { env });

/**
 * Live HubSpot record for one client — contact, company and ranked deals.
 * Deliberately a separate request: the table itself never calls HubSpot, so
 * this only runs for the client someone actually opened.
 */
export const fetchClientCrm = (organizationId, env) =>
  fetchWithFallback(
    `/usage-analytics/client-tracking/${organizationId}/crm`,
    {},
    { env, timeoutMs: 90000 },
  );

/**
 * AI recommendation for one client.
 *
 * POST because it costs a model call. The long timeout is deliberate: the
 * backend recomputes the client's window, fetches HubSpot and then calls
 * Gemini, and cutting that off at the default 60s would fail requests that
 * were about to succeed.
 */
export const fetchClientRecommendation = (organizationId, params, env) =>
  fetchWithFallback(
    `/usage-analytics/client-tracking/${organizationId}/recommendation`,
    params,
    { env, method: "POST", timeoutMs: 240000 },
  );
